import { spacings } from "@styles/DesignVariables";
import styled from "styled-components";

export const AuthorInfo = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${spacings.s6};

    @media screen and (max-width: 768px) {
        flex-wrap: wrap;
        max-width: 400px;
    }
`;

export const Center = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
`;
